import { CellValueChangedEvent } from "ag-grid-community";
import { FieldArrayWithId } from "react-hook-form";
import { IAttachment } from "../../../common/models/IAttachment";
import { IFormSection } from "../../../services/custom-forms-data-service/TemplateModels";
import { IFormInstanceData  } from "../../../views/object-form-view/Models";
import { FormAttachmentActionCardEnum } from "../../forms/form-attachment-card/FormAttachmentCard";
import FormPropertySection from "../../forms/form-property-section/FormPropertySection";
import { CustomFormRunnerModeType } from "../CustomFormRunner";
import { CustomFormType } from "../CustomFormRunnerUtils";
import CustomFormRenderControls from "./CustomFormRenderControls";

export type CustomFormSectionProps = {
    section: IFormSection;
    //instanceData?: IFormInstanceHistory;
    instanceData?: IFormInstanceData;
    onDataChanged?: (event: CellValueChangedEvent) => void;
    key?: React.Key | null | undefined,
    mode?: CustomFormRunnerModeType,

    attachments?: FieldArrayWithId<CustomFormType, "attachments", "fieldKey">[],
    onAttachmentAction: (action: FormAttachmentActionCardEnum,
        index: number,
        attachment: IAttachment) => void,
    onOpenCamera: () => void


};

export default function CustomFormSection({section,
    instanceData,
    onDataChanged,
    key,
    mode,
    attachments,
    onAttachmentAction,
    onOpenCamera

}: CustomFormSectionProps) {


     return (

        <FormPropertySection 
            key={key} 
            label={section.label} 
            //sx={{justifyContent: 'space-between'}}
            >
            <CustomFormRenderControls 
                controls={section.controls} 
                instanceData={instanceData} 
                onDataChanged={onDataChanged} 
                inSection={true}
                mode={mode}
                attachments={attachments} 
                onAttachmentAction={onAttachmentAction} 
                onOpenCamera={onOpenCamera} 
                />
        </FormPropertySection>

    );
}
